import { List } from "immutable";

import actionTypes from "../action-types";
import { ContentStat, ContentStatType } from "../models/state/contentStats";
import { CourseStat, CourseStatType } from "../models/state/courseStats";
import { SectionStat, SectionStatType } from "../models/state/sectionStats";
import { UserStat, UserStatType } from "../models/state/userStats";

export function receiveUserStudyStats(userStudyStats: UserStatType) {
  return {
    type: actionTypes.RECEIVE_USER_STUDY_STATS,
    payload: {
      userStudyStats
    }
  };
}

export function receiveReconciledUserStudyStats(userStudyStats: UserStat) {
  return {
    type: actionTypes.RECEIVE_RECONCILED_USER_STUDY_STATS,
    payload: {
      userStudyStats
    }
  };
}

type ReceivedStudyStats<EntityType> = {
  count: number;
  stats: Array<EntityType>;
};

export function receiveCourseStudyStats(
  courseStudyStats: ReceivedStudyStats<CourseStatType>
) {
  return {
    type: actionTypes.RECEIVE_COURSE_STUDY_STATS,
    payload: {
      courseStudyStats
    }
  };
}

export function receiveAllUserCoursesStats(
  allUserCoursesStats: ReceivedStudyStats<CourseStat>
) {
  return {
    type: actionTypes.RECEIVE_ALL_USER_COURSES_STATS,
    payload: allUserCoursesStats
  };
}

export function receiveReconciledCourseStudyStats(
  courseStudyStats: ReceivedStudyStats<CourseStat>
) {
  return {
    type: actionTypes.RECEIVE_RECONCILED_COURSE_STUDY_STATS,
    payload: {
      courseStudyStats
    }
  };
}

export function receiveSectionStudyStats(sectionStudyStats: SectionStatType[]) {
  return {
    type: actionTypes.RECEIVE_SECTION_STUDY_STATS,
    payload: {
      sectionStudyStats
    }
  };
}

export function receiveReconciledSectionStudyStats(
  sectionStudyStats: List<SectionStat>
) {
  return {
    type: actionTypes.RECEIVE_RECONCILED_SECTION_STUDY_STATS,
    payload: {
      sectionStudyStats
    }
  };
}

export function receiveContentStudyStats(contentStudyStats: ContentStatType[]) {
  return {
    type: actionTypes.RECEIVE_CONTENT_STUDY_STATS,
    payload: {
      contentStudyStats
    }
  };
}

export function receiveAndResetContentStudyStats(
  contentStudyStats: ContentStatType[],
  contentIds: List<string>
) {
  return {
    type: actionTypes.RECEIVE_AND_RESET_CONTENT_STUDY_STATS,
    payload: {
      contentStudyStats,
      contentIds
    }
  };
}

export function receiveReconciledContentStudyStats(
  contentStudyStats: List<ContentStat>
) {
  return {
    type: actionTypes.RECEIVE_RECONCILED_CONTENT_STUDY_STATS,
    payload: {
      contentStudyStats
    }
  };
}
